// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Border__border-a59ff3 {
  height: 24px;
  border-left: 1px solid var(--base-20);
  margin: 0 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingMenu/Content/components/Border/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qCAAA;EACA,aAAA;AACF","sourcesContent":[".border {\n  height: 24px;\n  border-left: 1px solid var(--base-20);\n  margin: 0 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"border": `Border__border-a59ff3`
};
module.exports = ___CSS_LOADER_EXPORT___;
